import React from 'react'
import { isServer } from "@lib/base/common";

export const LazyLoad = isServer() ? ({ children, serverChildren }) => serverChildren || children : require('react-lazyload').default;

// export const LazyLoad = require('react-lazyload').default;

